import React, { useEffect, useState } from 'react';

import { CardManagementFormWidget } from '../widgets/billing/CardManagementFormWidget';
import { useSystem } from '../../../../hooks/useSystem';
import { JourneyNavigationHandler, Routes } from '../../../../routes';
import { observer } from 'mobx-react';
import { styled } from '../../../../theme';
import { CenterFormWidget } from '../../../../widgets/layout/CenterFormWidget';

export interface UpdatePlanCardDialogWidgetProps {
  handler: JourneyNavigationHandler<Routes.PLAN_CARD_SETTINGS>;
}

export const UpdatePlanCardDialogWidget: React.FC<UpdatePlanCardDialogWidgetProps> = observer(({ handler }) => {
  const { org_id, plan_id } = handler.params;
  const system = useSystem();
  const org = system.orgStore.current_org;
  const plan = org?.plans.items?.find((p) => p.model.id === plan_id);
  const [selected, setCard] = useState<string>();

  useEffect(() => {
    if (plan) {
      setCard(plan.model.payment_configuration!);
    }
  }, [plan?.model?.id]);

  return (
    <S.Container loading={!plan} primaryLabel="Update card" noLogo={true}>
      <CardManagementFormWidget
        back={{
          label: 'Cancel',
          action: () => {
            handler.navigate(Routes.MANAGE_PLANS, {
              ...handler.params
            });
          }
        }}
        next={{
          label: 'Save',
          action: async (event, loader) => {
            loader(true);
            await plan!.setPaymentConfiguration(selected!);
            handler.navigate(Routes.MANAGE_PLANS, {
              ...handler.params
            });
          }
        }}
        org_id={org_id}
        desc="Select or add a card for this subscription. This will be the card that is automatically charged at the end of billing cycle."
        cardAdded={(config_id) => {
          setCard(config_id);
        }}
        generateCard={(card, element) => {
          const _selected = card.model.id === selected;
          return (
            <S.Card
              onClick={() => {
                setCard(card.model.id);
              }}
            >
              {React.cloneElement(element, { selected: _selected })}
              <S.CardSelected selected={_selected}>Selected</S.CardSelected>
            </S.Card>
          );
        }}
      />
    </S.Container>
  );
});

namespace S {
  export const Container = styled(CenterFormWidget)`
    max-width: 600px;
    width: 600px;
  `;

  export const Card = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    flex-direction: column;
  `;

  export const CardSelected = styled.div<{ selected: boolean }>`
    opacity: ${(p) => (p.selected ? 1 : 0)};
    font-size: 14px;
    margin-top: 10px;
    color: ${(p) => p.theme.text.primary};
  `;
}
